import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { SubmenuSettings } from "../../../lib/types/submenu-model/submenu-model"

type SubmenuInitial = {
    entities: SubmenuSettings
}

export const initialState: SubmenuInitial = {
    entities: {
        isCollapsed: false
    }
}

export const submenuSlice = createSlice({
    name: 'submenu',
    initialState: initialState,
    selectors: {
        getSubmenuSettings: (state) => state.entities,
        getSubmenuCollapse: (state) => state.entities.isCollapsed
    },
    reducers: {
        setSubmenuCollapse: (state, action: PayloadAction<{isCollapsed: boolean}>) => {
            state.entities.isCollapsed = action.payload.isCollapsed
        }
    }

})